exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider-container[data-v-e64a7b36]{display:flex;flex-direction:column;align-items:center;width:100%}input[type=range][data-v-e64a7b36]{width:100%}.slider-labels[data-v-e64a7b36]{display:flex;justify-content:space-between;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e64a7b36","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/procedure/procedure-viewing-elements/element-view-slider.vue
// module id = 1339
// module chunks = 0